/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import { CLUB, KICKABOUT_CASUAL } from '../../const';
import { AccordionDownArrow, AccordionUpArrow } from '../Icons';
import SessionCard from '../SessionCard';
import TeamCard from '../TeamCard';
import Text from '../Text';
import useStyles from './styles';

const INITIAL_SHOWN_CARDS = 3;

const ExpandableList = ({
  index: analyticsIndex,
  title,
  list,
  type,
  ariaLabel,
  cardAction,
  clubname,
  groupGender,
}) => {
  const [expandAnimation, setExpandAnimation] = useState(false);

  const styles = useStyles();
  const cardToFocus = useRef();

  const Card = type === KICKABOUT_CASUAL ? SessionCard : TeamCard;
  const isTeamCard = type === CLUB;

  const handleExpand = () => {
    setExpandAnimation(!expandAnimation);
  };

  const handleArrow = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      handleExpand();
    }
  }

  return (
    <div css={styles.base(isTeamCard)}>
      <div css={styles.accordionHead}>
        <Text as="h3" size={6} css={styles.title} onClick={handleExpand}>
          {title}
          {expandAnimation ? <AccordionUpArrow viewBox="2.33 2.33 23.33 23.33" css={styles.accordionButtonUp} tabIndex={0} onKeyDown={handleArrow}
            role="button" /> : <AccordionDownArrow viewBox="2.33 2.33 23.33 23.33" css={styles.accordionButtonDown} tabIndex={0} onKeyDown={handleArrow}
            role="button" />}
        </Text>
      </div>
      {expandAnimation === true && (
        <div css={styles.accordionBody}>
          <ul aria-label={ariaLabel}>
            {list &&
              list.length > 0 &&
              list.map((card, index) => (
                <li
                  key={card.SessionId || card.TeamId}
                  tabIndex={-1}
                  // if card is the first hidden one we pass the ref for focus
                  ref={index === INITIAL_SHOWN_CARDS ? cardToFocus : null}
                >
                  <Card
                    index={analyticsIndex}
                    {...card}
                    onClick={() => cardAction(card)}
                    clubname={clubname}
                    gender={title}
                    groupGender={card.Gender}
                  />
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

ExpandableList.propTypes = {
  index: PropTypes.number,
  title: PropTypes.string,
  list: PropTypes.object,
  type: PropTypes.number,
  ariaLabel: PropTypes.string,
  cardAction: PropTypes.func,
  clubname: PropTypes.string,
  groupGender: PropTypes.string,
};

export default ExpandableList;
